import { render, staticRenderFns } from "./blog-list.vue?vue&type=template&id=d32daafe&scoped=true"
import script from "./blog-list.vue?vue&type=script&lang=js"
export * from "./blog-list.vue?vue&type=script&lang=js"
import style0 from "./blog-list.vue?vue&type=style&index=0&id=d32daafe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32daafe",
  null
  
)

export default component.exports